import React, { FC } from 'react'

import { styled } from '@linaria/react'

import { AcceptMessage } from 'components/block/Footer/AcceptMessage'
import { Copyright } from 'components/block/Footer/Copyright'
import { RecommendationTechnologiesMessage } from 'components/block/Footer/RecommendationTechnologiesMessage'
import { SupportLink } from 'components/block/Footer/SupportLink'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { Typography } from 'components/designSystem/Typography/Typography'

export const FooterInfo: FC = () => {
  return (
    <AgreementTextContainer>
      <AcceptMessage>
        {(chunks) => <Text fontSize={11}>{chunks}</Text>}
      </AcceptMessage>

      <Text fontSize={11}>
        <RecommendationTechnologiesMessage />
      </Text>

      <Typography fontSize={11}>
        <SupportLink />
      </Typography>

      <DesktopTypography fontSize={11}>
        <Copyright />
      </DesktopTypography>
    </AgreementTextContainer>
  )
}

const Text = styled(Typography)`
  color: var(--foreground-muted);
`
const DesktopTypography = styled(Typography)`
  color: var(--foreground-muted);

  a {
    /* Переписываем стиль тег "a", потому что используется старый компонент. */
    color: var(--info-soft);
  }

  @media screen and (max-width: ${breakpoints.mobile - 1}px) {
    display: none;
  }
`

const AgreementTextContainer = styled.div`
  margin-top: auto;
  padding: var(--spacing-16px) 0;
  text-align: center;

  & > * + * {
    margin-top: var(--spacing-8px);
  }
`
